import { render, staticRenderFns } from "./PointsExchangeMapiPayPage.vue?vue&type=template&id=7d6a32f5&scoped=true"
import script from "./PointsExchangeMapiPayPage.vue?vue&type=script&lang=js"
export * from "./PointsExchangeMapiPayPage.vue?vue&type=script&lang=js"
import style0 from "./PointsExchangeMapiPayPage.vue?vue&type=style&index=0&id=7d6a32f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6a32f5",
  null
  
)

export default component.exports